module.exports = __webpack_public_path__ + "static/logic_gate-34a9175ec42c49dfaaf2888d37ab146d.png";